export const currenciesConstants = {
  GET_CURRENCIES_REQUEST: "GET_CURRENCIES_REQUEST",
  GET_CURRENCIES_SUCCESS: "GET_CURRENCIES_SUCCESS",
  GET_CURRENCIES_FAILURE: "GET_CURRENCIES_FAILURE",
  GET_CURRENCIES_RESET: "GET_CURRENCIES_RESET",

  VIEW_CURRENCY_REQUEST: "VIEW_CURRENCY_REQUEST",
  VIEW_CURRENCY_SUCCESS: "VIEW_CURRENCY_SUCCESS",
  VIEW_CURRENCY_FAILURE: "VIEW_CURRENCY_FAILURE",
  VIEW_CURRENCY_RESET: "VIEW_CURRENCY_RESET",

  ADD_CURRENCY_REQUEST: "ADD_CURRENCY_REQUEST",
  ADD_CURRENCY_SUCCESS: "ADD_CURRENCY_SUCCESS",
  ADD_CURRENCY_FAILURE: "ADD_CURRENCY_FAILURE",
  ADD_CURRENCY_RESET: "ADD_CURRENCY_RESET",

  EDIT_CURRENCY_REQUEST: "EDIT_CURRENCY_REQUEST",
  EDIT_CURRENCY_SUCCESS: "EDIT_CURRENCY_SUCCESS",
  EDIT_CURRENCY_FAILURE: "EDIT_CURRENCY_FAILURE",
};
